(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrTerrainDialogController", TrTerrainDialogController);

    TrTerrainDialogController.$inject = [
        "$timeout",
        "$scope",
        "$state",
        "entity",
        "TrTerrain",
        "Configs",
        "route",
        "postRoutePoints",
        "AlertService",
        "$window",
        "TrRouteListIdName",
        "RoutePathById",
        "AllTerrainTypes",
        "AllCustomTerrainTypeAttribute",
        "$rootScope"
    ];

    function TrTerrainDialogController(
        $timeout,
        $scope,
        $state,
        entity,
        TrTerrain,
        Configs,
        route,
        postRoutePoints,
        AlertService,
        $window,
        TrRouteListIdName,
        RoutePathById,
        AllTerrainTypes,
        AllCustomTerrainTypeAttribute,
        $rootScope
    ) {
        var vm = this;
        vm.trTerrain = entity;
        vm.save = save;
        var entity_old = angular.copy(vm.trTerrain);
        vm.terrainType = entity.terrainType;
        var markers = []
        var coordinateList = []
        var chainageList = []
        var markerList = []
        var iconSize = 20
        var labelFrom, labelTo
        labelFrom = 'From Terrain'
        labelTo = 'To Terrain'
        vm.routeName = route
        vm.selectRoute = selectRoute;
        vm.selectAttributes = selectedTerrainTypeAttributes;
        vm.isSetUpdate = false;
        var coordinateList = [];
        var chainageList = [];
        var markerList = [];
        vm.terrainType = entity.terrainType;

        if ($state.params.routeId) {
            vm.trTerrain.routeId = parseInt($state.params.routeId, 10);
        }

        vm.customAttributesMap = {};
        vm.customAttributesMapp = [];
        loadPage();
        var locations = {};
        var locationsEnd = {};


        function loadPage() {

            vm.imageInNewTab = function (img) {
                var imgWindow = window.open();
                imgWindow.document.write(
                    '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
                );
                imgWindow.document.close();
            };
            TrRouteListIdName.get(function (response) {
                vm.routes = response;
            });


            var terrainTypeAttributeValuesList =
                vm.trTerrain.terrainTypeAttributeValues;

            try {
                for (var index in vm.trTerrain.terrainType.terrainTypeAttribute) {
                    if (
                        !checkIfTerrainTypeExists(
                            vm.trTerrain.terrainType.terrainTypeAttribute[index],
                            vm.trTerrain.terrainTypeAttributeValues
                        )
                    ) {
                        var terrainTypeAttribute1 =
                            vm.trTerrain.terrainType.terrainTypeAttribute[index];
                        terrainTypeAttributeValuesList.push({
                            terrainTypeAttribute: terrainTypeAttribute1,
                            attributeValue:
                                vm.trTerrain.terrainType.terrainTypeAttribute[index]
                                    .defaultValue,
                        });
                    }
                }
            } catch (e) { }

            function checkIfTerrainTypeExists(terrainType, terrainTypeAttrVal) {
                var hasTerrainType = false;
                for (var i = 0; i < terrainTypeAttrVal.length; i++) {
                    var name = terrainTypeAttrVal[i].terrainTypeAttribute.name;
                    if (name == terrainType.name) {
                        hasTerrainType = true;
                        break;
                    }
                }
                return hasTerrainType;
            }
            AllTerrainTypes.getAll(function (response) {
                vm.terrainTypes = response;
            });

            AllCustomTerrainTypeAttribute.getAll(function (response) {
                //vm.customTerrainTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    if (arrayItem.customTerrainTypeAttributeValues != undefined) {
                        vm.customAttributesMap[arrayItem.name] =
                            arrayItem.customTerrainTypeAttributeValues;
                        vm.customAttributesMap[arrayItem.name].parentId =
                            arrayItem.id;
                    }

                });
                if (vm.trTerrain.id) {
                    $(":file").filestyle({
                        buttonBefore: true,
                    });
                    $(":file").filestyle("buttonText", "Browse File");
                }
            });

        }
        // $timeout(function () {
        //     angular.element(".form-group:eq(1)>input").focus();
        // });

        function selectedTerrainTypeAttributes() {
            vm.showFilter = true;
            if (vm.terrainType) {
                vm.trTerrain.terrainType = vm.terrainType;
                if (
                    entity_old.terrainType &&
                    vm.terrainType.id === entity_old.terrainType.id
                ) {
                    vm.trTerrain.terrainTypeAttributeValues = [];
                    vm.trTerrain.terrainTypeAttributeValues =
                        entity_old.terrainTypeAttributeValues;
                } else {
                    vm.trTerrain.terrainTypeAttributeValues = [];
                    $.each(
                        vm.terrainType.terrainTypeAttribute,
                        function (key, value) {
                            vm.trTerrain.terrainTypeAttributeValues.push({
                                terrainTypeAttribute:
                                    vm.terrainType.terrainTypeAttribute[key],
                            });
                        }
                    );
                }
            }
        } 

        function selectRoute() {
            markers.forEach(function(marker){
                marker.setMap(null);
            });
            coordinateList = [];
            chainageList = [];
            markerList = [];
            locations.map
            initMap();
            RoutePathById.get(vm.trTerrain.routeId, function (response) {
                var groupedSessions = {};
                if (response.COORDINATE) {
                    response.COORDINATE.forEach(function (value) {
                        if(value.sessionNumber!=null){
                        if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].coordinates.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                   }
                    });
                }
                if (response.CHAINAGE) {
                    response.CHAINAGE.forEach(function (value) {
                        if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].chainages.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                    });
                }
                
                if(response.MARKER){
                    response.MARKER.forEach(function (value) {
                        if (!groupedSessions[value.sessionNumber]) {
                            groupedSessions[value.sessionNumber] = { coordinates: [], markers: [], chainages: [] };
                        }
                        groupedSessions[value.sessionNumber].markers.push({ lat: value.latitude, lng: value.longitude , routePointNumber: value.routePointNumber });
                    });
                }
                Object.keys(groupedSessions).forEach(function (sessionNumber) {
                    var sessionData = groupedSessions[sessionNumber];
                    sessionData.coordinates.sort(function (a, b) { return a.routePointNumber - b.routePointNumber });
                    if (sessionData.coordinates.length) {
                        var polyline = new google.maps.Polyline({
                            path: sessionData.coordinates,
                            geodesic: true,
                            strokeColor: '#FD7A24',
                            strokeOpacity: 1.0,
                            strokeWeight: 4,
                        });
                        polyline.setMap(locations.map);
                        addClick(polyline);
                        var bounds = new google.maps.LatLngBounds();
                        sessionData.coordinates.forEach(function (coord) {
                            bounds.extend(coord);
                        });
                        locations.map.fitBounds(bounds);
                    }
                    if (sessionData.chainages.length) {
                        createMarkers(sessionData.chainages, 'content/images/chainagePoints.png', locations.map);
                    }
                    if (sessionData.markers.length) {
                        createMarkers(sessionData.markers, 'content/images/markersPoint.png', locations.map);
                    }
                });
            });
        }

        function addClick(item) {
            // Add a click event listener to the map
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    // Add a marker to the map
                    addMarker(event.latLng);

                    // Get the latitude and longitude of the clicked point
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }

        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                addClick(marker)
                arr.push(marker);
            })
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                }
            });

            // Add the marker to the markers array
            markers.push(marker);
        }

        function save() {
            if (markers.length == 2) {
                var payload
                markers.forEach(function (item) {
                    if (item.label.text == labelFrom || item.label.text == labelTo) {
                        if (item.label.text == labelFrom) {
                            vm.trTerrain.fromRoutePoint = {};
                            vm.trTerrain.fromRoutePoint.latitude = item.position.lat();
                            vm.trTerrain.fromRoutePoint.longitude = item.position.lng();
                        }
                        if (item.label.text == labelTo) {
                            vm.trTerrain.toRoutePoint = {};
                            vm.trTerrain.toRoutePoint.latitude = item.position.lat();
                            vm.trTerrain.toRoutePoint.longitude = item.position.lng();
                            if(vm.trTerrain.id != null){
                                TrTerrain.update(vm.trTerrain, onSaveSuccess, onSaveError);
                            } else {
                                TrTerrain.save(vm.trTerrain, onSaveSuccess, onSaveError);
                            }
                            
                        }
                    }
                })
            } else {
                alert("Terrain From or To Points are Empty")
            }

        }
		
		
		vm.closeModal = function(id) {
		          vm.getLocationCoordinateA = null
		          vm.getLocationCoordinateB = null

		          $("#" + id).removeClass("in");
		          $(".modal-backdrop").remove();
		          $("#" + id).hide();
		      }
			  
			  vm.onLocationCoordinates = function() {
			             var latlngA = vm.getLocationCoordinateA.split(",");
			             var latlngB = vm.getLocationCoordinateB.split(",");

			             addMarker({lat: parseFloat(latlngA[0]),lng: parseFloat(latlngA[1])})
			             addMarker({lat: parseFloat(latlngB[0]),lng: parseFloat(latlngB[1])})

			             locations.map.setCenter({lat: parseFloat(latlngB[0]),lng: parseFloat(latlngB[1])})
			             vm.closeModal('modalLatLongs')
			         }
        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:terrainUpdate", result);
            //vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            if (pageValue == "user-management.new") {
                $state.go("user-management.new");
            } else {
                $window.history.back();
            }
        }

        function onSaveError() {
            //vm.isSaving = false;
        }

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = response;
            //vm.workFlow.phase = "Planning Phase"
            /*  if(vm.workFlow.id == null){
                response.forEach(function(val){
                    if(val.configValue == '01'){
                        vm.workFlow.phase = val.configKey
                    }
                })
            }*/
        });

        //start
        initMap();
        function initMap(){
            locations.map = new google.maps.Map(
                document.getElementById("map_canvasStart"),
                {
                    center: {
                        lat: parseFloat($rootScope.DEFAULT_LATITUDE),
                        lng: parseFloat($rootScope.DEFAULT_LONGITUDE),
                    },
                    zoom: 13,
                    fullscreenControl: true,
                    styles: mapStyles(),
                }
            );


            geoLocation(locations.map);
        }

        if (vm.trTerrain.id == null) {
            selectRoute();
        }
        if (vm.trTerrain.id != null) {
            selectRoute();
        } else {
            vm.trTerrain.phase = "PLANNING"
        }

        function geoLocation(map) {
            var infoWindow = new google.maps.InfoWindow();
            var locationButton = document.createElement("button");
            locationButton.setAttribute("title", "Locate Me");
            locationButton.classList.add("custom-map-control-button");
            var geoIcon = document.createElement("i");
            geoIcon.classList.add("fa");
            geoIcon.classList.add("fa-crosshairs");
            geoIcon.classList.add("geo");
            locationButton.appendChild(geoIcon);
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
                locationButton
            );
			
			var goTo = document.createElement("span");
			            goTo.setAttribute("title", "Location Coordinates");
			            goTo.classList.add("custom-map-control-button");
			            var gotoIcon = document.createElement("i");
			            gotoIcon.classList.add("fa");
			            gotoIcon.classList.add("fa-location-arrow");
			            gotoIcon.classList.add("geo");
			            gotoIcon.classList.add("mt-5");
			            goTo.appendChild(gotoIcon);
			            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);
			            goTo.addEventListener("click", function () {
			                vm.removeMarker()
			                $("#modalLatLongs").show();
			     });

            locationButton.addEventListener("click", function () {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.setCenter(pos);
                            map.setZoom(18);
                        },
                        function () {
                            handleLocationError(
                                true,
                                infoWindow,
                                map.getCenter()
                            );
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0,
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter());
                }
            });

            function handleLocationError(
                browserHasGeolocation,
                infoWindow,
                pos
            ) {
                infoWindow.setPosition(pos);
                infoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                infoWindow.open(map);
            }
        }

        function mapStyles() {
            var styles;
            return (styles = [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ]);
        }

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles(),
            });
        }

        vm.removeMarker = function () {
            markers.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markers = [];

            if (vm.trTerrain.id) {
                vm.isSetUpdate = true
            }

        }

        // if (route && route.routePoints != null && route.routePoints.length) {
        //     route.routePoints.forEach(function (each) {
        //         if (each.routePointType == "COORDINATE") {
        //             coordinateList.push({ lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber })
        //         } else if (each.routePointType == "MARKER") {
        //             markerList.push({ lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber })
        //         } else if (each.routePointType == "CHAINAGE") {
        //             chainageList.push({ lat: each.latitude, lng: each.longitude, routePointNumber: each.routePointNumber })
        //         }
        //     })
        //     coordinateList.sort(function(a, b) { return a.routePointNumber - b.routePointNumber});
        //     if (coordinateList.length) {
        //         locations.map.setCenter(coordinateList[0]);
        //         var polyline = new google.maps.Polyline({
        //             path: coordinateList,
        //             geodesic: true,
        //             strokeColor: '#FD7A24',
        //             strokeOpacity: 1.0,
        //             strokeWeight: 4,
        //         });

        //         // Set the map to display the polyline
        //         polyline.setMap(locations.map);
        //         addClick(polyline)
        //     }
        //     markerList.sort(function(a, b) { return a.routePointNumber - b.routePointNumber});
        //     if (markerList.length) {
        //         locations.map.setCenter(markerList[0]);
        //         createMarkers(markerList, 'content/images/markersPoint.png', locations.map)
        //     }
        //     chainageList.sort(function(a, b) { return a.routePointNumber - b.routePointNumber});
        //     if (chainageList.length) {
        //         locations.map.setCenter(chainageList[0]);
        //         createMarkers(chainageList, 'content/images/chainagePoints.png', locations.map)
        //     }
        // }


        //Functions

        function addClick(item) {
            // Add a click event listener to the map
            item.addListener("click", function (event) {
                if (markers.length < 2) {
                    // Add a marker to the map
                    addMarker(event.latLng);

                    // Get the latitude and longitude of the clicked point
                    vm.pinLat = event.latLng.lat();
                    vm.pinLong = event.latLng.lng();
                } else {
                    console.log("Maximum 2 markers allowed.");
                }
            });
        }


        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(
                            iconSize / 2,
                            iconSize / 2
                        ),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                addClick(marker)
                arr.push(marker);
            })
        }

        function addMarker(location) {
            var markerText
            if (markers.length == 0) {
                markerText = labelFrom
            } else if (markers.length == 1) {
                markerText = labelTo
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: "content/images/sections.png",
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        -4
                    ),
                    labelOrigin: new google.maps.Point(25, 22),
                },
                label: {
                    text: markerText,
                }
            });

            // Add the marker to the markers array
            markers.push(marker);
        }


        if (vm.trTerrain.id && vm.trTerrain.fromRoutePoint && vm.trTerrain.toRoutePoint) {
            addMarker({ lat: vm.trTerrain.fromRoutePoint.latitude, lng: vm.trTerrain.fromRoutePoint.longitude })
            addMarker({ lat: vm.trTerrain.toRoutePoint.latitude, lng: vm.trTerrain.toRoutePoint.longitude })
            locations.map.setCenter({ lat: vm.trTerrain.fromRoutePoint.latitude, lng: vm.trTerrain.fromRoutePoint.longitude });
        }

        $('.select2').select2();
    }
})();

